import React, { useState, useEffect } from 'react';

interface SophisticatedAddressProps {
	parts: string[];
	locationQuery: string;
}

const SophisticatedAddress: React.FC<SophisticatedAddressProps> = ({ parts, locationQuery }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const fullAddress = parts.join(', ');

	useEffect(() => {
		if (isExpanded) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
		return () => {
			document.body.style.overflow = '';
		};
	}, [isExpanded]);

	const handleToggle = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsExpanded(!isExpanded);
	};

	const isMobile = window.innerWidth <= 768;

	return (
		<>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
					width: '100%',
				}}
			>
				<span
					onClick={handleToggle}
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						fontSize: 'inherit',
						color: '#555',
						cursor: 'pointer',
						textAlign: 'right',
						flex: 1,
					}}
				>
					{fullAddress}
				</span>
				<a
					href={`https://maps.google.com/?q=${locationQuery}`}
					target='_blank'
					rel='noreferrer'
					style={{
						flexShrink: 0,
						fontSize: '14px',
						color: '#e74c3c',
						textDecoration: 'none',
						display: 'flex',
						alignItems: 'center',
						marginLeft: '4px',
					}}
					title='Open in Google Maps'
				>
					<svg width='14' height='14' viewBox='0 0 24 24' fill='currentColor' style={{ margin: '0 2px' }}>
						<path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' />
					</svg>
				</a>
			</div>

			{isExpanded && isMobile && (
				<div
					onClick={() => setIsExpanded(false)}
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0,0,0,0.09)',
						zIndex: 9998,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'flex-start',
						paddingTop: '58px',
					}}
				>
					<div
						onClick={(e) => e.stopPropagation()}
						style={{
							backgroundColor: '#fff',
							border: '1px solid #e2e8f0',
							borderRadius: '12px',
							padding: '10px 16px',
							width: '88%',
							maxWidth: '350px',
							boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
							textAlign: 'center',
							position: 'relative',
							animation: 'popIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
						}}
					>

						<style>
							{`
								@keyframes popIn {
									from { transform: scale(0.95) translateY(-10px); opacity: 0; }
									to { transform: scale(1) translateY(0); opacity: 1; }
								}
							`}
						</style>
						<p
							style={{
								margin: 0,
								fontSize: '13px',
								color: '#334155',
								userSelect: 'text',
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								lineHeight: '1.5',
								position: 'relative',
								zIndex: 2,
								textAlign: 'center',
							}}
						>
							{fullAddress}
						</p>
					</div>
				</div>
			)}

			{isExpanded && !isMobile && (
				<div
					onClick={() => setIsExpanded(false)}
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0,0,0,0.09)',
						zIndex: 9998,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'flex-start',
						paddingTop: '102px',
					}}
				>
					<div
						onClick={(e) => e.stopPropagation()}
						style={{
							backgroundColor: '#fff',
							border: '1px solid #e2e8f0',
							borderRadius: '12px',
							padding: '12px 20px',
							width: '90%',
							maxWidth: '600px',
							boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
							textAlign: 'center',
							position: 'relative',
							animation: 'popInDesktop 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
						}}
					>

						<style>
							{`
								@keyframes popInDesktop {
									from { transform: scale(0.98) translateY(-10px); opacity: 0; }
									to { transform: scale(1) translateY(0); opacity: 1; }
								}
							`}
						</style>
						<p
							style={{
								margin: 0,
								fontSize: '14px',
								color: '#334155',
								userSelect: 'text',
								whiteSpace: 'normal',
								wordBreak: 'break-word',
								lineHeight: '1.6',
								position: 'relative',
								zIndex: 2,
								textAlign: 'center',
							}}
						>
							{fullAddress}
						</p>
					</div>
				</div>
			)}
		</>
	);
};

export default SophisticatedAddress;
